import styled from 'styled-components';

export const Wrapper = styled.div`
  max-height: fit-content;

  a {
    font-size: 16px;

    text-decoration: none;

    color: var(--darkGrey);

    @media screen and (max-width: 576px) {
      font-size: 12px;
    }
  }

  .footer {
    background-color: #f7f7f7;
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
  }
`;
